import { Component, OnInit, ViewChild } from "@angular/core";
import {AbstractControl,FormControl,FormGroup,ValidatorFn,Validators} from "@angular/forms";
import { Router } from "@angular/router";
import { DialogUtils } from "@app/DialogUtils";
import { MessageUtils } from "@app/MessageUtils";
import { User } from "@app/models/User";
import { AuthService } from "@app/services/auth/auth.service";
import { CaptchaService } from "@app/services/captcha/captcha.service";
import { UserService } from "@app/services/user/user.service";
import { ValidateUtils } from "@app/ValidateUtils";
import { AppService, SessionStorageService } from "@mova/components/core";
import { MvRecaptcha } from "@mova/components/recaptcha";
import { forkJoin, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-cudi-login-view",
  templateUrl: "./cudi-login-view.component.html",
  styleUrls: ["./cudi-login-view.component.scss"],
})
export class CudiLoginViewComponent implements OnInit {
  formLogin: FormGroup;

  //Campos del formulario
  cdNifNie: FormControl;
  tipoDocumento: FormControl;
  cdMailUniversidad: FormControl;
  conditions: FormControl;

  // Suscripción del formulario.
  formSubscription: Subscription;
  formValid: boolean;

  selectOptionsDocumento = [
    {
      id: 1,
      text: "NIF/NIE",
    },
    {
      id: 2,
      text: "Pasaporte",
    },
  ];

  @ViewChild('captcha', {static: false}) captchaValue: MvRecaptcha;
  private captchaValueValue: string;

  labelNifNiePassport: string;

  constructor(
    private _authService: AuthService,
    private router: Router,
    private _appService: AppService,
    private _captchaService: CaptchaService,
    private _sessionStorageService: SessionStorageService,
    private _userService: UserService,
  ) {}

  ngOnInit(): void {
    this.confirmAccess();
    this.confirmBaja();
    this.confirmLinkAvailable();
    this.createFormLogin();
    this.formValid = this.formLogin.status === "VALID" ? true : false;
    this.onChanges();
    this.formLogin.controls.tipoDocumento.setValue(1, {onlySelf: true});
    this.labelNifNiePassport = this.selectOptionsDocumento[(this.formLogin.controls.tipoDocumento.value)-1].text;


  }

  /**
   * Comprueba si el email ha sido verificado.
   * En caso de estar el email verificado, mostrará un mensaje indicándolo.
   */
  confirmAccess() {
    let confirm = this._sessionStorageService.getItem(MessageUtils.CONFIRM_ACCESS);
    let dialog = DialogUtils.getDialogError();

    switch (confirm) {
      case "pendiente":
        dialog = DialogUtils.getDialogConfirmEmail();
        this._sessionStorageService.clearItem(MessageUtils.CONFIRM_ACCESS);
        this._appService.openDialog(dialog);
        break;
      case "alta":
        dialog = DialogUtils.getDialogError(MessageUtils.TEXT_ALTA);
        this._sessionStorageService.clearItem(MessageUtils.CONFIRM_ACCESS);
        this._appService.openDialog(dialog);
        break;
      case "baja":
        dialog = DialogUtils.getDialogError(MessageUtils.TEXT_BAJA);
        this._sessionStorageService.clearItem(MessageUtils.CONFIRM_ACCESS);
        this._appService.openDialog(dialog);
      default:
        break;
    }


  }

  /**
   * Comprueba si el usuario se ha dado de baja.
   * En caso de estar de baja, mostrará un mensaje indicándolo.
   */
   confirmBaja() {
    if (this._sessionStorageService.getItem(MessageUtils.CONFIRM_BAJA)) {
      let dialogEmail = DialogUtils.getDialogConfirmBaja();
      this._appService.openDialog(dialogEmail);
      this._sessionStorageService.clearItem(MessageUtils.CONFIRM_BAJA);
    }
  }

  /**
   * Comprueba si ha habido algún link que ya no esté disponible..
   * En caso de que no esté disponible, mostrará un mensaje indicándolo.
   */
   confirmLinkAvailable() {
    if (this._sessionStorageService.getItem(MessageUtils.LINK_AVAILABLE) == 'false') {
      let dialoLink = DialogUtils.getDialogLinkNotAvailable();
      this._appService.openDialog(dialoLink);
      this._sessionStorageService.clearItem(MessageUtils.LINK_AVAILABLE);
    }
  }

  /**
   * Validación del captcha
   * @response En caso no haber ningún error.
   * @error En caso de haber algún error en la petición.
   *
   */
  captchaValidation(){
    this.captchaValueValue = this.captchaValue.getLastSuccessCaptcha();

    this._captchaService.captchaValidations$(this.captchaValueValue).subscribe(
      response => {
        return true;
      },
      error => {
        return false;
      }
    );
  }

  /**
   * Crea el formulario para los datos del usuario.
   */
  private createFormLogin() {
    this.formLogin = new FormGroup({
      cdNifNie: new FormControl("", [
        Validators.required
      ]),
      tipoDocumento: new FormControl("", [Validators.required]),
      cdMailUniversidad: new FormControl("", [
        Validators.required,
        Validators.email,
      ]),
      conditions: new FormControl("", [Validators.required]),

    });

    this.setFormControlUserVariables();
  }

  /**
   * Establece el controlador de variables del formulario formLogin.
   */
  private setFormControlUserVariables() {
    this.cdNifNie = this.formLogin.controls.cdNifNie as FormControl;
    this.tipoDocumento = this.formLogin.controls.tipoDocumento as FormControl;
    this.cdMailUniversidad = this.formLogin.controls.cdMailUniversidad as FormControl;
    this.conditions = this.formLogin.controls.conditions as FormControl;
  }

  onChangeTipoDocumento() {
    if (this.formLogin.controls.tipoDocumento.value == 1) {

      this.formLogin.controls.cdNifNie.clearValidators();
      this.formLogin.controls.cdNifNie.setValidators(ValidateUtils.validateNifPassportForm);
    } else {

      this.formLogin.controls.cdNifNie.clearValidators();
      this.formLogin.controls.cdNifNie.setValidators(Validators.pattern('[-a-zA-Z0-9]*'));
    }

    this.formLogin.controls.cdNifNie.updateValueAndValidity();
  }

  /**
   * Por cada cambio en el formulario, verificará la validez.
   */
  onChanges(): void {

    this.formSubscription = this.formLogin.valueChanges.subscribe((val) => {
      if (
        this.formLogin.status === "VALID" &&
        this.formLogin.controls.conditions.value == true
      ) {
        this.formValid = true;
      } else {
        this.formValid = false;
      }
      this.labelNifNiePassport = this.selectOptionsDocumento[(this.formLogin.controls.tipoDocumento.value)-1].text;

    });
  }

  /**
   * Valida que el Nif/Pasaporte sea correcto.
   * @param control Control del formulario.
   * @returns null en caso de ser correcto.
   * @return object en caso de no ser correcto.
   */
  validateNifPassport(control: AbstractControl) {
    if (ValidateUtils.validateNifPassport(control.value)) {
      return null;
    }

    return { valid: false };
  }

  /**
   * Abre un modal con información sobre las condiciones.
   */
  openDialogCondiciones() {
    let data = DialogUtils.getDialogCondiciones();

    this._appService.openDialog(data);
  }

  /**
   * Abre un modal con información sobre el correo institucional.
   */
  openDialogInfoCorreoInstitucional() {
    let dialogCorreo = DialogUtils.getDialogInfoCorreoInstitucional();
    this._appService.openDialog(dialogCorreo);
  }

  /**
   * Devuelve un error custom de formulario
   * @param campo Campo a comprobar el mensaje de error.
   * @returns
   */
  getFormCustomErrorMessage(campo) {
    return MessageUtils.getFormCustomErrorMessage(campo, this.formLogin);
  }

  /**
   * Da a elegir entre dos opciones si el usuario intenta loguearse.
   * Enviar Email -> Envía un email al usuario para darse de alta en la aplicación
   * si no lo ha hecho.
   * @param dialogError Diálogo con las opciones a elegir.
   * @param cdNifNie Nif del usuario.
   * @param cdMailUniversidad Mail de universidad del usuario
   */
  checkOpcionLoginEmail(dialogError, cdNifNie, cdMailUniversidad) {
    let self = this;
    function successCallback(result: any) {
      if (result.accept) {
        self.sendEmailPending(dialogError, cdNifNie, cdMailUniversidad);
      }
    }

    dialogError["successCallback"] = successCallback;
    this._appService.openDialog(dialogError);

  }

/**
   * Envía el email pendiente de confirmación al usuario que intenta acceder al login.
   * @param dialogError Diálogo con las opciones a elegir.
   * @param cdNifNie Nif del usuario.
   * @param cdMailUniversidad Mail de universidad del usuario
   */
  sendEmailPending(dialogError, cdNifNie, cdMailUniversidad) {
    let dialogEmail = DialogUtils.getDialogLogin();
    this._userService.sendPendingEmail(cdNifNie, cdMailUniversidad).toPromise()
    .then(reqEmail => this._appService.openDialog(dialogEmail))
    .catch(error => this._appService.openDialog(dialogError))

    // this._userService.sendPendingEmail(cdNifNie, cdMailUniversidad).subscribe((reqEmail) => {

    //   this._appService.openDialog(dialogError);
    //
    // }, (error) => {
    //   let dialogError = DialogUtils.getDialogError();
    //   this._appService.openDialog(dialogError);
    // })
  }

  /**
   * Envia el formulario y el usuario recibirá un email si existe, en caso contrario recibirá un error indicándolo.
   */
  onSubmit() {
    let captchaValue = this.captchaValue.getLastSuccessCaptcha();
    let dni = this.formLogin.controls.cdNifNie.value;
    let email = this.formLogin.controls.cdMailUniversidad.value;

    //Login sin captcha
    // this._authService.login(dni, email).subscribe(

    //   (data) => {
    //     let dialogCorreo = DialogUtils.getDialogLogin();
    //     this._appService.openDialog(dialogCorreo);
    //   },
    //   (error) => {
    //
    //     let dialogError = DialogUtils.getDialogError(error.error.localizedMessage);

    //     this._appService.openDialog(dialogError);

    //   }
    // );

    /**
     * Valida primero si el captcha es válido.
     */
    this._captchaService.captchaValidations$(captchaValue).subscribe((reqCaptcha) => {
      this._authService.login(dni, email).subscribe((reqLogin) => {

        this._userService.getUser(dni, email).subscribe((reqUser) => {
          let user:User = reqUser.data.data;

          if (reqLogin != undefined && reqLogin.data.data.cdUsuAlta == undefined) {
            //Pendiente de confirmar email '1'
            if (user.vfEstado == '1') {
              let dialogError = DialogUtils.getDialogLoginEmail(reqLogin.data.data);

              this.checkOpcionLoginEmail(dialogError, dni, email);
            } else {
              let dialogError = DialogUtils.getDialogError(reqLogin.data.data);
              this._appService.openDialog(dialogError);
            }

          } else {
            let dialogCorreo = DialogUtils.getDialogLogin();
            this._appService.openDialog(dialogCorreo);
          }

        })


        this.reloadPage();

      }, (error) => {

        if (!this.formLogin.valid) {
          let dialogError = DialogUtils.getDialogError(error.error.localizedMessage);
          this._appService.openDialog(dialogError);
        }
      })
    }, (error) => {

      if (this.captchaValue.getLastSuccessCaptcha().length == 0) {
        let dialogError = DialogUtils.getDialogError("No se ha completado el captcha");
        this._appService.openDialog(dialogError);
      } else {
        let dialogError = DialogUtils.getDialogError();
        this._appService.openDialog(dialogError);
      }
    })
  }


  /**
   * Recarga la página completamente.
  */
  reloadPage() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/login-view']);
  }

  onDestroy() {
    this._sessionStorageService.clearItem(MessageUtils.CONFIRM_ACCESS);
    this._sessionStorageService.clearItem(MessageUtils.CONFIRM_BAJA);
    this._sessionStorageService.clearItem(MessageUtils.LINK_AVAILABLE);

  }

}
